module.exports = __webpack_public_path__ + "static/media/web-design-v3.91009d1a.mp4";